import "./index.scss";

import React, { useEffect, useRef, useState } from "react";
import { Route, useHistory, useLocation } from "react-router-dom";

import { useAuth0 } from "@auth0/auth0-react";
import Dialog from "@material-ui/core/Dialog";
import FinanceService from "Lib/API/Finance";
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import AlertDialog from "components/Dialog/index";
import MyButton from "components/MyButton";
import Button from "components/button/Button";
import MainTabs from "components/mainTabs/MainTabs";
import { formatDate } from "helper/dateFormat";
import { SubHeader } from "layout/SubHeader";
import { debounce } from "lodash";
import moment from "moment";
import { useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";
import { SetRecurringChecks } from "../../app/redux/actions/index";
import MyModal from "../../components/MyModal";
import NotAuthorized from "../../components/NotAuthorized";
import { setAccountTransaction } from "../../pages/commonSlice";
import {
  HidePaymentInfoButton,
  dispacthPayNowRow,
} from "../../store/redux/actions/index";
import BatchBillingTable from "./BatchBillingTable/BatchBillingTable";
import { BatchDocuments } from "./BatchDocuments/BatchDocuments";
import { NewBatchDocument } from "./BatchDocuments/NewBatchDocument/NewBatchDocument";
import { Deposits } from "./Deposits/deposits";
import Documents from "./Documents/Documents";
import InvoiceDocument from "./Documents/InvoiceDocument";
import ReceiptDocument from "./Documents/ReceiptDocument";
import ShareDocumentsModal from "./Documents/ShareDocumentsModal/index";
import StatementDocument from "./Documents/StatementDocument";
import TaxReportDocoment from "./Documents/TaxReportDocument";
import ViewDocumentModal from "./Documents/ViewDocumentModal/index";
import { FinanceFilter } from "./FinanceFilter";
import NewBatchBillinCharge from "./NewBatchBillinCharge";
import NewCharge from "./NewCharge";
import UserContext from "./NewChargeContext";
import NewTaxReport from "./NewTaxReport/NewTaxReport";
import NewTaxStatement from "./NewTaxStatement/NewTaxStatement";
import ChargesTable from "./TransactionsTable";
import PaymentPlans from "./PaymentPlans/PaymentPlans";
import PaymentPlansFilter from "./PaymentPlans/PaymentPlansFilter";

const initialFilters = {
  sort: {},
  search: undefined,
  filter: {
    "hidden": true
  }
};


const tabOptions = [
  {
    title: "Transactions",
    value: "Transactions",
    width: "150px",
  },
  {
    title: "Bulk Billing",
    value: "Bulk Billing",  
    width: "150px",
  },
  {
    title: "Documents",
    value: "Documents",
    width: "150px",
  },
  // {
  //   title: "Bulk Documents",
  //   value: "Bulk Documents",
  //   width: "150px",
  // },
  {
    title: "Deposits & Sync",
    value: "Deposits & Sync",
    width: "150px",
  },
  {
    title: "Payment Plans",
    value: "Payment Plans",
    width: "150px",
  },
];

const Finance = () => {
  const dispatch = useDispatch();
  const [toggle, setToggle] = useState("Transactions");
  const [paymentPlanFilter, setPaymentPlanFilter] = useState({});
  const [loading, setLoading] = useState(false);
  const [list /* setList */] = useState([]);
  const [open, setOpen] = useState(false);
  const [openTaxStatement, setOpenTaxStatement] = useState(false);
  const [OpenBatchDocument, setOpenBatchDocument] = useState(false);
  const [openTaxReport, setOpenTaxReport] = useState(false);
  const [fileData, setFileData] = useState("");
  const [file, setFile] = useState([]);
  const [isFinanceActive, setIsFinanceActive] = useState(true);
  const [viewDocument, setviewDocument] = useState("");
  const [documentData, setdocumentData] = useState([]);
  const [documentType, setDocumentType] = useState("");
  const [downloadPDF, setDownloadPDF] = useState("");
  const [sharePDF, setSharePDF] = useState("");
  const [closeNewTaxReport, setCloseNewTaxReport] = useState(false);
  const [closeNewStatementReport, setCloseNewStatementReport] = useState(false);
  const [paymentExpandable, setPaymentExpandable] = useState(true);
  const [closeCheck, setCloseCheck] = useState(false);

  const [goSetting, setGoSetting] = useState(0);

  const [stepOne, setStepOne] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [sortData, setSortData] = useState(initialFilters);
  const [searchOptions, setsearchoptions] = useState();
  const [data, setData] = useState({});
  const [isSaved, setSaved] = useState(false);
  const [hfinish, setHFinish] = useState(false);
  const [openBatch, setOpenBatch] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [productData, setProductData] = useState();
  const [count, setCount] = useState();
  const [page, setPage] = useState(0);
  const [batchId, setBatchId] = useState(null);
  const [editData, setEditData] = useState({});
  const [rowData, setRowData] = useState({});
  const [stepper, setStepper] = useState("New Charge");
  const [financeTablePage, setFinanceTablePage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(30);
  const [modalOpen, setModalOpen] = React.useState("");
  const [stepIndex, setStepIndex] = useState("");
  const [batchList, setBatchList] = useState(false);
  const [localFormat, setLocalFormat] = useState(false);

  const [resetChecks, setResetchecks] = useState(false);
  const [calendar, setCalender] = useState(false);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [switchType, setSwitchType] = useState("charge");
  const [viewDocumentId, setViewDocumentId] = React.useState(null);
  const [openShareModal, setOpenShareModal] = React.useState(false);
  const [documentRow, setDocumentRow] = React.useState(null);
  const [exportChargeData, setExportChargeData] = useState({})
  const [exportPaymentData, setExportPaymentData] = useState({})
  const [viewDocumentContent, setViewDocumentContent] = useState(null);
  const [confirmClose, setConfirmClose] = useState(false);
  useEffect(() => {
    if (goSetting || filters?.search) {
      setFinanceTablePage(0);
      setPage(0);
    }
  }, [goSetting, filters]);

  const [datePaid, setPaidRange] = useState([null, null]);
  const [startPaidDate, endPaidDate] = datePaid;

  const fetchMyAPI = async () => {
    const token = await getAccessTokenSilently();

    if (sortData?.filter) {
      delete sortData?.filter;
    }
    await FinanceService.getListofBatchBilling(token, page + 1, 10, sortData)
      .then((res) => {
        const result = res?.payload?.data;

        setProductData(result);
        setCount(res?.payload?.pagination?.count);
      })
      .catch((error) => {
        toastr.error(error?.data?.message);
      });
  };

  const option2 =
    productData &&
    productData?.map((item, index) => ({
      id: item?._id,
      name: item?.batch_name,
    }));
  useEffect(() => {
    window.addEventListener("save-transaction", fetchMyAPI);
    return () => window.removeEventListener("save-transaction", fetchMyAPI);
  }, [sortData, page, getAccessTokenSilently]);

  const sortCharged = (e) => {
    setFilters((prev) => ({
      ...prev,
      sort: {
        [e]: prev.sort[e] === 1 ? -1 : 1,
      },
    }));
  };
  useEffect(() => {
    if (startDate && endDate) {
      setFilters((prev) => ({
        ...prev,
        filter: {
          ...prev.filter,
          charge_date: {
            start: moment(startDate).format("MM/DD/YYYY"),
            end: moment(endDate).format("MM/DD/YYYY"),
          },
          hidden: true,
        },
      }));
    }
    if (startDate === null && endDate === null) {
      setFilters({
        sort: {},
        search: filters?.search,
      });
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (startPaidDate && endPaidDate) {
      setFilters((prev) => ({
        ...prev,
        filter: {
          ...prev.filter,
          paid_at: {
            start: moment(startPaidDate).format("MM/DD/YYYY"),
            end: moment(endPaidDate).format("MM/DD/YYYY"),
          },
          hidden: true,
        },
      }));
    }
    if (startPaidDate === null && endPaidDate === null) {
      setFilters({
        sort: {},
        search: filters?.search,
      });
    }
  }, [startPaidDate, endPaidDate]);

  const onChargeDateChange = (e) => {
    // setLocalFormat(true);
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        charge_date: e
          ? {
            start: moment(e?.[0]).format("MM/DD/YYYY"),
            end: moment(e?.[1]).format("MM/DD/YYYY"),
          }
          : undefined,
        hidden: true,
      },
    }));
  };

  const onPaidDateChange = (e) => {
    setLocalFormat(true);
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        paid_at: e
          ? {
            start: moment(e?.[0]).format("MM/DD/YYYY"),
            end: moment(e?.[1]).format("MM/DD/YYYY"),
          }
          : undefined,
        hidden: true,
      },
    }));
  };

  const onAccountChange = (e) => {
    console.log("e", e);
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        accountId: e?.id ?? undefined,
        hidden: true,
      },
    }));
  };


  const onAmountChange = (e) => {
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        amount: e ?? undefined,
        hidden: true,
      },
    }));
  };

  const onChargedStatusChange = (e) => {
    const values = Array.isArray(e)
      ? e.map((item) => {
          const v = item?.value ?? item;
          return v === "partially paid" ? "partially_paid" : v;
        })
      : undefined;
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        charge_status: values?.length ? values : undefined,
        hidden: true,
      },
    }));
  };

  const onPaymentStatusChange = (e) => {
    const values = Array.isArray(e)
      ? e.map((item) => {
          const v = item?.value ?? item;
          return v === "partialy applied" ? "partialy_applied" : v;
        })
      : undefined;
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        hidden: true,
        payment_status: values?.length ? values : undefined,
      },
    }));
  };

  const onStatusChange = (status) => {
    setFilters((prev) => ({
      ...prev,
      status: (status !== "All" && status !== "COA" && status !== "Partial" && status !== "Paid") ? status?.toLowerCase() : undefined,
      filter: {
        ...prev.filter,
        charge_type: status === "COA" ? "credit_on_account" : undefined,
      }
    }));
    setFinanceTablePage(0);
    setPaymentExpandable(false);
  };

  const onOverdueDaysChange = (e) => {
    console.log("the old filter", filters);
    console.log("onOverdueDaysChange", e, e?.value);
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        hidden: true,
        overdue: e?.value ? e?.value : undefined,
      },
    }));
    console.log("the new filter", filters);
  };

  const onIdChange = (e) => {
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        id: e ?? undefined,
        hidden: true,
      },
    }));
  };


  const onFieldChange = (name, value) => {
    const statusArrayFields = ["installmentStatus", "recurringStatus"];
    const normalizedValue =
      statusArrayFields.includes(name) && Array.isArray(value)
        ? value.map((item) => item?.value ?? item)
        : value;
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        hidden: true,
        [name]: normalizedValue,
      },
    }));
  };


  const restChargePaymentFilter = (name) => {
    setFilters((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        [name]: undefined,
      },
    }));
  }
  

  const onClear = () => {
    setExportChargeData({});
    setExportPaymentData({});
    setResetchecks(true);
  };

  const onPayNowClick = ({ detail }) => {
    // alert("index.js");
    setData({
      ...detail,
      type: "pay-now",
    });
    setOpen(true);
  };
  const onChargeEditClick = ({ detail }) => {
    setData({
      ...detail,
      type: "edit-charge",
    });
    setOpen(true);
  };

  useEffect(() => {
    // alert("index.js");
    document.addEventListener("pay-now", onPayNowClick);
    return () => document.removeEventListener("pay-now", onPayNowClick);
  }, []);

  useEffect(() => {
    document.addEventListener("edit-charge", onChargeEditClick);
    return () => document.removeEventListener("edit-charge", onChargeEditClick);
  }, []);

  const onPayAllClick = ({ detail }) => {
    setData({
      allData: detail,
      type: "pay-all",
    });
    setOpen(true);
  };

  useEffect(() => {
    document.addEventListener("pay-all", onPayAllClick);
    return () => document.removeEventListener("pay-all", onPayAllClick);
  }, []);

  useEffect(() => {
    if (data?.type === "pay-now" || data?.type === "pay-all") {
      setStepIndex(1);
    } else {
      setStepIndex(0);
    }
  });
  const onModalClose = () => {
    if (isSaved || hfinish) {
      closeModal();
      dispatch(SetRecurringChecks("hide"));
      // localStorage.setItem("setRecurring", "false");-
    } else {
      closeModal();
      dispatch(SetRecurringChecks("hide"));
      // localStorage.setItem("setRecurring", "false");
    }
  };

  const handlefieldClick = (e) => {
    if (e.stopPropagation) {
      e.stopPropagation();
    }
  };

  const [tableModel, setTableModel] = useState(false);

  const closeModal = () => {
    setStepOne(true);
    setOpen(false);
    setOpenBatch(false);
    setTableModel(true);
  };

  const addNewTransaction = () => {
    localStorage.setItem("TransStatus", "added");
    dispatch(SetRecurringChecks("hide"));
    // localStorage.setItem("setRecurring", "false");
    dispatch(HidePaymentInfoButton(false));

    dispatch(
      dispacthPayNowRow({
        tribute_info: {
          type: "",
          recipient_name: "",
          donor_name: "",
          assign_tribute: "",
          receipt: {
            id: "",
            name: "",
          },
          message: "",
          recipient_salutation: "",
          donor_salutation: "",
          send_letter_to: {
            email: "",
            address: "",
          },
        },
      })
    );
    setData({});
    setResetchecks(true);
    setOpen(true);
  };
  const addNewBatchCharge = () => {
    setOpenBatch(true);
  };

  const addNewTaxStatement = () => {
    setOpenTaxStatement(true);
  };
  const addNewBatchDocument = () => {
    setOpenBatchDocument(true);
  }
  const { push } = useHistory();

  console.log(batchId, "batch_idbatch_id")

  const handleClick = (tab, batch_id = null) => {
    console.log("tab", tab);
    if (batch_id) {
      setBatchId(batch_id);
      setModalOpen(true);
      return;
    } else {
      setBatchId(null);
    }
    setToggle(tab?.value);
    if (tab?.value !== "Payment Plans") {
      setPaymentPlanFilter({});
    }
    if (tab?.value === "Bulk Billing") {
      push({
        pathname: "/finance/batch",
      });
    } else if (tab?.value === "Documents") {
      setFilters((prev) => ({
        ...prev,
        status: undefined,
      }));
      push({
        pathname: "/finance/documents",
      });
    } else if (tab?.value === "Bulk Documents") {
      push({
        pathname: "/finance/batch-documents",
      });
    } else if (tab?.value === "Deposits & Sync") {
      push({
        pathname: "/finance/deposits",
      });
    } else if (tab?.value === "Payment Plans") {
      push({
        pathname: "/finance/payment-plans",
      });
    } else {
      push({
        pathname: "/finance",
      });
    }
    setFilters((prev) => ({
      ...prev,
      status: undefined,
    }));

  };
  const { pathname, search } = useLocation();
  const [openFilter, setOpenFilter] = useState(false);

  // Apply overdue filter when navigated here from dashboard via ?overdue=N
  const _sp = new URLSearchParams(search);
  const overdueParam = _sp.get("overdue");
  const chargeStatusParam = _sp.get("charge_status");
  const ledgerParams = _sp.getAll("ledger");
  const subLedgerParams = _sp.getAll("subLedger");

  const ledgerExtra = {};
  if (ledgerParams.length) ledgerExtra.ledger = ledgerParams;
  if (subLedgerParams.length) ledgerExtra.subLedger = subLedgerParams;

  const overdueApplied = useRef(null);
  useEffect(() => {
    if (!overdueParam || overdueApplied.current === overdueParam) return;
    overdueApplied.current = overdueParam;
    const days = +overdueParam;
    // setTimeout(0): defer until after FinanceFilter's formik mount effects flush,
    // which otherwise call onOverdueDaysChange(undefined) and clear the filter.
    const timerId = setTimeout(() => {
      setFilters((prev) => ({
        ...prev,
        filter: { ...prev.filter, hidden: true, overdue: days, ...ledgerExtra },
      }));
      setGoSetting((n) => n + 1);
    }, 0);
    return () => clearTimeout(timerId);
  }, [overdueParam]);  // eslint-disable-line react-hooks/exhaustive-deps

  // Apply charge_status filter when navigated here from dashboard via ?charge_status=open
  const chargeStatusApplied = useRef(null);
  useEffect(() => {
    if (!chargeStatusParam || chargeStatusApplied.current === chargeStatusParam) return;
    chargeStatusApplied.current = chargeStatusParam;
    const timerId = setTimeout(() => {
      setFilters((prev) => ({
        ...prev,
        filter: { ...prev.filter, hidden: true, charge_status: [chargeStatusParam], ...ledgerExtra },
      }));
      setGoSetting((n) => n + 1);
    }, 0);
    return () => clearTimeout(timerId);
  }, [chargeStatusParam]);  // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (pathname === "/finance") {
      setOpenBatch(false);
      setToggle("Transactions");
    } else if (pathname.includes("batch-documents")) {
      setToggle("Bulk Documents");
    } else if (pathname.includes("batch")) {
      setToggle("Bulk Billing");
    } else if (pathname.includes("documents")) {
      setToggle("Documents");
    } else if (pathname.includes("deposits")) {
      setToggle("Deposits & Sync");
    } else if (pathname.includes("payment-plans")) {
      setToggle("Payment Plans");
    }
  });

  useEffect(() => {
    dispatch(setAccountTransaction(null));
    setCalender(false);
  }, [endDate]);

  useEffect(() => {
    setFilters(initialFilters);
  }, [pathname]);


  useEffect(() => {
    if (closeNewTaxReport == true) {
      setOpenTaxReport(false);
    } else if (closeNewStatementReport == true) {
      setOpenTaxStatement(false);
    }
    setCloseNewTaxReport(false);
    setCloseNewStatementReport(false);
  }, [closeNewTaxReport, closeNewStatementReport]);

  let orgInfo =
    localStorage.getItem("authorizedModules") !== undefined
      ? JSON.parse(localStorage.getItem("authorizedModules"))
      : [];

  useEffect(() => {
    let check = orgInfo?.map((item) => {
      if (item?.moduleName == "finance") {
        return setIsFinanceActive(item?.active);
      }
    });
    setIsFinanceActive(
      orgInfo?.find((item) => item?.moduleName === "finance")?.active
    );
  }, []);


  const viewDocumentHandler = (documentId) => {
    setViewDocumentId(documentId);
  }

  const viewLetterHandler = (documentContent) => {
    setViewDocumentContent(documentContent);
  }



  const downloadFileHandler = async (row) => {
    const { _id, name, type } = row;
    const token = await getAccessTokenSilently();
    await FinanceService.downloadDocument(token, _id).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const currentDate = formatDate({ date: new Date(), formatType: "defaultWithUTC" });
      const fileType = type === "tax_statement" ? "Statement" : type.charAt(0).toUpperCase() + type.slice(1);
      const fileName = `${fileType}_${name.replaceAll(" ", "_")}_${currentDate}`
      link.setAttribute('download', `${fileName}.pdf`);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
    });
  }


  const documentHandler = (row) => {
    setOpenShareModal(true);
    setDocumentRow(row);
  }



  const onFilterGoClicked = () => {
    setFinanceTablePage(0);
    setGoSetting((n) => n + 1);
    setResetchecks(true);
  }


  const closeFinanceModal = () => {
    setConfirmClose(true);
  }

  const confirmCloseFinanceModal = () => {
    setConfirmClose(false);
    if(openTaxReport) {
      setOpenTaxReport(false);
      setCloseCheck(!closeCheck);
    } else if (openTaxStatement) {
      setOpenTaxStatement(false);
      setCloseCheck(!closeCheck);
    } else {
      onModalClose();
      setOpenBatchDocument(false);
      setOpenBatch(false);
    }

  }
  

  

  return !isFinanceActive ? (
    <NotAuthorized title={"Finances"} />
  ) : (
    <div className="members pr-3 pr-sm-12 pt-10">
      {openBatch ? (
        ""
      ) : (
        <>
          <div className="d-flex justify-content-between align-items-center"
            style={{
              minHeight: "48px",
            }}
          >
            <SubHeader
              className="subheader"
              {...{
                title: "Finances",
                color: "#2455EF",
              }}
            />
            <div className="d-flex">
              <div className="mr-5">
                {toggle === "Documents" ? (
                  <Button
                    variant="primary"
                    onClick={() => setOpenTaxReport(true)}
                  >
                      <PlusIcon />
                      <span>Tax Report</span>
                  </Button>
                ) : ""}
              </div>
              {toggle !== "Deposits & Sync" && toggle !== "Payment Plans" && (
                <Button
                    variant="primary"
                    style={{ fontWeight: 500 }}
                    onClick={
                      toggle === "Bulk Billing"
                        ? addNewBatchCharge
                        : toggle === "Documents"
                          ? addNewTaxStatement
                          : toggle === "Bulk Documents" ?
                            addNewBatchDocument
                            : addNewTransaction
                    }
                  >
                    <PlusIcon />
                    <span>
                      {toggle === "Bulk Billing" ? "New Bulk Charge" : toggle === "Documents" ? "New Statement" : toggle === "Bulk Documents" ? "New Batch" : "New Transaction"}
                    </span>
                </Button>
              )}
            </div>
          </div>
          <MainTabs
            className={"mt-5 mb-5 mb-4"}
            tabs={tabOptions}
            onTabsChange={handleClick}
            activeTab={toggle === "Bulk Documents" ? "Documents" : toggle}
          />
        </>
      )}
      {toggle === "Transactions" ? (
        <>
          <FinanceFilter
            filter={filters}
            setGoSetting={setGoSetting}
            goSetting={goSetting}
            onAccountChange={onAccountChange}
            onIdChange={onIdChange}
            onChargeDateChange={onChargeDateChange}
            onPaidDateChange={onPaidDateChange}
            onAmountChange={onAmountChange}
            onChargedStatusChange={onChargedStatusChange}
            onPaymentStatusChange={onPaymentStatusChange}
            onOverdueDaysChange={onOverdueDaysChange}
            onClear={onClear}
            onStatusChange={onStatusChange}
            setFilters={setFilters}
            initialFilters={initialFilters}
            // dueDateFilter={dueDateFilter}
            // setDueDateFilter={setDueDateFilter}
            toggle={toggle}
            localFormat={localFormat}
            setDateRange={setDateRange}
            setPaidRange={setPaidRange}
            startPaidDate={startPaidDate}
            endPaidDate={endPaidDate}
            startDate={startDate}
            endDate={endDate}
            calendar={calendar}
            setCalender={setCalender}
            loadingForDisable={loading}
            switchType={switchType}
            setSwitchType={setSwitchType}
            onFieldChange={onFieldChange}
            onFilterGoClicked={onFilterGoClicked}
            openFilter={openFilter}
            setOpenFilter={setOpenFilter}
          />
          <div className="charges-table">
            <ChargesTable
              tableModel={tableModel}
              setTableModel={setTableModel}
              page={financeTablePage}
              filter={filters}
              setGoSetting={setGoSetting}
              goSetting={goSetting}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              setPage={setFinanceTablePage}
              list={productData}
              loading={loading}
              setLoading={setLoading}
              filters={filters}
              sortData={sortData}
              sortCharged={sortCharged}
              paymentExpandable={paymentExpandable}
              setPaymentExpandable={setPaymentExpandable}
              batchList={batchList}
              setBatchList={setBatchList}
              resetChecks={resetChecks}
              setResetchecks={setResetchecks}
              switchType={switchType}
              setSwitchType={setSwitchType}
              bulkPayment={switchType === "payment" ? true : false}
              toggle={toggle}
              viewDocumentHandler={viewDocumentHandler}
              downloadFileHandler={downloadFileHandler}
              documentHandler={documentHandler}
              setExportPaymentData={setExportPaymentData}
              setExportChargeData={setExportChargeData}
              exportChargeData={exportChargeData}
              exportPaymentData={exportPaymentData}
              restChargePaymentFilter={restChargePaymentFilter}
              viewLetterHandler={viewLetterHandler}
              showTabs={true}
            />
          </div>
        </>
      ) : toggle === "Bulk Billing" ?
        (
          <Route path="/finance/batch">
            <>
              {openBatch ? (
                <UserContext.Provider value={{ editData }}>
                  <NewBatchBillinCharge
                    setStepOne={setStepOne}
                    handleClose={onModalClose}
                    closeModal={closeFinanceModal}
                    data={data}
                    activeIndex={editData ? 0 : 0}
                    setSaved={setSaved}
                    handleClick={handleClick}
                    editData={editData}
                  />
                </UserContext.Provider>
              )
                : (
                  <>
                    <div className="Billing-table">
                      <BatchBillingTable
                        list={list}
                        loading={loading}
                        filters={filters}
                        sort={sortData}
                        sortCharged={sortCharged}
                        setsearchoptions={setsearchoptions}
                        page={page}
                        setCount={setCount}
                        productData={productData}
                        setProductData={setProductData}
                        setPage={setPage}
                        count={count}
                        handleClick={handleClick}
                        setBatchId={setBatchId}
                        setOpenBatch={setOpenBatch}
                        setEditData={setEditData}
                        batch_id={batchId}
                        modalOpen={modalOpen}
                        batchList={batchList}
                        setBatchList={setBatchList}
                      />
                    </div>
                  </>
                )}
            </>
          </Route>
        ) : (
          toggle === "Documents" ? (
            <Route path="/finance/documents">
              <Documents
                filter={filters}
                onStatusChange={onStatusChange}
                sortCharged={sortCharged}
                viewDocument={setviewDocument}
                documentData={setdocumentData}
                downloadPDF={setDownloadPDF}
                sharePDF={setSharePDF}
                fileData={fileData}
                file={file}
                closeNewTaxReport={closeNewTaxReport}
                closeNewStatementReport={closeNewStatementReport}
                closeCheck={closeCheck}
                setFilters={setFilters}
                viewDocumentHandler={viewDocumentHandler}
                downloadFileHandler={downloadFileHandler}
              />
            </Route>
          ) : 
            (toggle === "Bulk Documents" ? (
              <Route path="/finance/batch-documents">
                <BatchDocuments closeCheck={closeCheck} />
              </Route>
            ) : (toggle === "Deposits & Sync" ? (
              <Deposits />
            ) : (toggle === "Payment Plans" ? (
              <>
                <PaymentPlansFilter filter={paymentPlanFilter} setFilter={setPaymentPlanFilter} />
                <PaymentPlans filter={paymentPlanFilter} />
              </>
            ) : "")))

        )}
      <MyModal
        className={
          stepOne
            ? "new-charge-modal"
            : stepper === "white"
              ? "new-charge-modal modal-step-one "
              : "new-charge-modal-w modal-step-two "
        }
        open={open}
        onClose={closeFinanceModal}
        onClick={(e) => handlefieldClick(e)}
        activeIndex={stepIndex}
      >
        <UserContext.Provider value={{ hfinish, setHFinish }}>
          <NewCharge
            setStepper={setStepper}
            setStepOne={setStepOne}
            handleClose={onModalClose}
            setData={setData}
            data={data}
            activeIndex={
              data?.type === "pay-now" || data?.type === "pay-all" ? 1 : 0
            }
            setSaved={setSaved}
            setBatchList={setBatchList}
            
          />
        </UserContext.Provider>
      </MyModal>
      <MyModal
        open={openTaxStatement}
        // className={
        //   stepOne
        //     ? "new-charge-modal"
        //     : stepper === "white"
        //     ? "new-charge-modal modal-step-one "
        //     : "new-charge-modal-w modal-step-two "
        // }
        className="newTaxStatement-modal"
        onClose={closeFinanceModal}
      >
        <NewTaxStatement
          documentType={setDocumentType}
          documentData={setdocumentData}
          downloadPDF={setDownloadPDF}
          sharePDF={setSharePDF}
          closeModal={closeFinanceModal}
          viewDocumentHandler={viewDocumentHandler}
          downloadFileHandler={downloadFileHandler}
          documentHandler={documentHandler}
        />
      </MyModal>{" "}
      <MyModal
        open={OpenBatchDocument}
        // className={
        //   stepOne
        //     ? "new-charge-modal"
        //     : stepper === "white"
        //     ? "new-charge-modal modal-step-one "
        //     : "new-charge-modal-w modal-step-two "
        // }
        className="newBatchDocuments-modal"
        onClose={closeFinanceModal}
      >
        <NewBatchDocument setOpenBatchDocument={setOpenBatchDocument} setCloseCheck={setCloseCheck} closeCheck={closeCheck} />
      </MyModal>{" "}
      <MyModal
        open={openTaxReport}
        onClose={closeFinanceModal}
        // className={
        //   stepOne
        //     ? "new-charge-modal"
        //     : stepper === "white"
        //     ? "new-charge-modal modal-step-one "
        //     : "new-charge-modal-w modal-step-two "
        // }
        className="newTaxStatement-modal"
      >
        <NewTaxReport
          documentType={setDocumentType}
          documentData={setdocumentData}
          downloadPDF={setDownloadPDF}
          sharePDF={setSharePDF}
          closeModal={closeFinanceModal}
          viewDocumentHandler={viewDocumentHandler}
          downloadFileHandler={downloadFileHandler}
          documentHandler={documentHandler}
        />
      </MyModal>
      <MyModal
        className={
          stepOne
            ? "new-charge-modal"
            : stepper === "white"
              ? "new-charge-modal modal-step-one "
              : "new-charge-modal-w modal-step-two "
        }
        // className="document-modal"
        open={
          viewDocument === "tax_report"
            ? true
            : documentType === "tax_report"
              ? true
              : downloadPDF === "tax_report"
                ? true
                : sharePDF === "tax_report"
                  ? true
                  : false
        }
        onClose={() => {
          setviewDocument(false);
          setDocumentType("");
          setDownloadPDF("");
          setSharePDF("");
          setOpenTaxReport(false);
          setOpenTaxStatement(false);
          setCloseCheck(!closeCheck);
        }}
      >
        <TaxReportDocoment
          data={documentData}
          downloadPDF={downloadPDF}
          sharePDF={sharePDF}
          setFileData={setFileData}
          setFile={setFile}
        />
      </MyModal>
      <MyModal
        className={
          stepOne
            ? "new-charge-modal"
            : stepper === "white"
              ? "new-charge-modal modal-step-one "
              : "new-charge-modal-w modal-step-two "
        }
        // className="document-modal"
        open={
          viewDocument == "invoice"
            ? true
            : downloadPDF == "invoice"
              ? true
              : sharePDF == "invoice"
                ? true
                : false
        }
        onClose={() => {
          setviewDocument("");
          setDownloadPDF("");
          setSharePDF("");
          setOpenTaxReport(false);
          setOpenTaxStatement(false);
          setCloseCheck(!closeCheck);
        }}
      >
        <InvoiceDocument
          setFileData={setFileData}
          setFile={setFile}
          data={documentData}
          downloadPDF={downloadPDF}
          sharePDF={sharePDF}
          setDownloadPDF={setDownloadPDF}
        />
      </MyModal>
      <MyModal
        className={
          stepOne
            ? "new-charge-modal"
            : stepper === "white"
              ? "new-charge-modal modal-step-one "
              : "new-charge-modal-w modal-step-two "
        }
        // className="document-modal"
        open={
          viewDocument == "receipt"
            ? true
            : downloadPDF == "receipt"
              ? true
              : sharePDF == "receipt"
                ? true
                : false
        }
        onClose={() => {
          setviewDocument("");
          setDownloadPDF("");
          setSharePDF("");
          setOpenTaxReport(false);
          setOpenTaxStatement(false);
        }}
      >
        <ReceiptDocument
          data={documentData}
          downloadPDF={downloadPDF}
          sharePDF={sharePDF}
          setFileData={setFileData}
          setFile={setFile}
        />
      </MyModal>
      <MyModal
        className={
          stepOne
            ? "new-charge-modal"
            : stepper === "white"
              ? "new-charge-modal modal-step-one "
              : "new-charge-modal-w modal-step-two "
        }
        // className="document-modal"
        open={
          viewDocument === "tax_statement"
            ? true
            : documentType === "tax_statement"
              ? true
              : downloadPDF === "tax_statement"
                ? true
                : sharePDF === "tax_statement"
                  ? true
                  : false
        }
        onClose={() => {
          setviewDocument("");
          setDocumentType("");
          setDownloadPDF("");
          setSharePDF("");
          setOpenTaxReport(false);
          setOpenTaxStatement(false);
          setCloseCheck(!closeCheck);
        }}
      >
        <StatementDocument
          data={documentData}
          downloadPDF={downloadPDF}
          sharePDF={sharePDF}
          setFileData={setFileData}
          setFile={setFile}
        />
      </MyModal>
      <Dialog
        open={viewDocumentId !== null || viewDocumentContent !== null}
        onClose={() => {
          setViewDocumentId(null);
          setViewDocumentContent(null);
        }}
        PaperProps={{
          style: {
            width: "888px",
            height: "90vh",
            overflow: "hidden",
            borderRadius: "22px",
          },
        }}
        fullWidth
        maxWidth={"md"}
      > 
        <ViewDocumentModal
          documentHtmlContent={viewDocumentContent ? viewDocumentContent : null}
          documentId={viewDocumentId ? viewDocumentId : null}
          closeModal={() => {
            setViewDocumentId(null);
            setViewDocumentContent(null);
          }}
        />
      </Dialog>
      <Dialog
        open={openShareModal}
        onClose={() => {
          setOpenShareModal(false);
        }}
        PaperProps={{
          style: {
            width: "888px",
            height: "637px",
            overflowX: "hidden",
            borderRadius: "22px",
          },
        }}
        fullWidth
        maxWidth={"md"}
      >
        <ShareDocumentsModal
          closeModal={() => {
            setOpenShareModal(false);
          }}
          documentsIds={[documentRow?._id]}
          documentType={documentRow?.type}
          defaultEmail={documentRow?.account_details?.defaultEmails || []}
          type="Document"
        />
      </Dialog>
      {/* <MyModal
        className={stepOne ? "new-charge-modal" : "new-charge-modal-w"}
        open={openBatch}
        onClose={onModalClose}
      >
        <UserContext.Provider value={{ hfinish, setHFinish }}> */}
      {/* </UserContext.Provider>
      </MyModal> */}
      <AlertDialog
        open={confirmClose}
        handleClose={() => setConfirmClose(false)}
        onDecline={() => {
          setConfirmClose(false);
        }}
        onAccept={confirmCloseFinanceModal}
        title={"Are you sure?"}
        description={`Do you want to discard the changes you made?`}
      />
    </div>
  );
};

export default Finance;
